import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';
import { Container, Label, ImgWrapper, DriverName } from './styles';
import { Phone } from '../styles';
import { ORDER_STATE_PENDING_ASSIGNMENT } from '../../../utils/constants';
// const NO_DRIVER_LOGO = 'https://quiqup-track.s3.amazonaws.com/images/quiqup_roundel_rgb_navy_green.png';
// const defaultQuiqeeImg = transportMode => `https://quiqup-track.s3.amazonaws.com/images/${transportMode}.png`;

const getDriverStatus = jobState => {
  switch (jobState) {
    case ORDER_STATE_PENDING_ASSIGNMENT:
      return "We'll assign a driver to you shortly";
    default:
      return 'Your driver is on his way';
  }
};
class DriverCard extends PureComponent {
  static propTypes = {
    quiqee: PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      transportMode: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
    }).isRequired,
    showPhone: PropTypes.bool.isRequired,
    jobState: PropTypes.string.isRequired,
  };

  render() {
    const { quiqee, showPhone, jobState } = this.props;
    // const imageSrc = quiqee ? quiqee.imageUrl || defaultQuiqeeImg(quiqee.transportMode) : NO_DRIVER_LOGO;
    // const imageAlt = quiqee ? quiqee.name : 'Quiqup Logo';

    return (
      <Container>
        <Label>Driver</Label>
        <ImgWrapper hasQuiqee={!!quiqee}>
          <QuIcon icon="q-logo-v2" width={48} height={48} />
          {/* <img src={imageSrc} alt={imageAlt} /> */}
        </ImgWrapper>
        {quiqee ? (
          <Fragment>
            <DriverName showPhone={showPhone}>
              {quiqee.name} ({quiqee.transportMode})
            </DriverName>
            {showPhone && <Phone href={`tel:${quiqee.phone}`}>{quiqee.phone}</Phone>}
          </Fragment>
        ) : (
          <DriverName isAssigned={false}>{getDriverStatus(jobState)}</DriverName>
        )}
      </Container>
    );
  }
}

export default DriverCard;



// WEBPACK FOOTER //
// ./src/app/order-card/driver-card/DriverCard.js